export const validateMemberCardContactMethod = (
    contactMethod: number[] = [],
    values: { phone?: string; wx_qr_code_img?: string } = {},
) => {
    if (contactMethod.length < 1) return '请至少选择一种店铺联系方式'
    if (contactMethod.includes(0) && !values.phone) return '请填写店铺联系电话'
    if (contactMethod.includes(1) && !values.wx_qr_code_img) return '请上传微信二维码'

    return ''
}

export const getMemberCardConfigSubmitParams = (values: {
    card_face_theme: number
    app_recharge: boolean
    member_pay_password_enabled?: boolean
    contact_method?: number[]
    phone?: string
    wx_qr_code_img?: string
}) => {
    const contactMethod = values.contact_method || []

    return {
        card_face_theme: values.card_face_theme,
        app_recharge: values.app_recharge ? 0 : -1,
        member_pay_password_enabled: values.member_pay_password_enabled ?? true,
        contact_method: contactMethod,
        phone: contactMethod.includes(0) ? values.phone : undefined,
        wx_qr_code_img: values.wx_qr_code_img,
    }
}
